export default __webpack_public_path__ + "static/media/szafy11.5658de6c.jpg";